import React, { memo } from 'react'
import { getTranslatableField } from '@sentecacommerce-theme/lib'
import {
  CheckboxFilter,
  FilterWrapper,
  TextWithLinkFilter,
  SearchFilter,
} from './Components'

const filtersMap: any = {
  checkbox: CheckboxFilter,
  'attribute-checkbox': CheckboxFilter,
  'range-checkbox': CheckboxFilter,
  'text-with-link': TextWithLinkFilter,
  autocomplete: SearchFilter,
}

export const customSort = (a: any, b: any) => {
  const aPart =
    Number(
      getTranslatableField(a?.data?.meta?.valueLabel)?.match(/\d+|\D+/g)?.[1]
    ) ?? 0
  const bPart =
    Number(
      getTranslatableField(b?.data?.meta?.valueLabel)?.match(/\d+|\D+/g)?.[1]
    ) ?? 0

  return aPart - bPart
}

const EmptyFilter = () => null

export const Aggregates = memo(({ data }: { data: any }) => {
  return (
    <>
      {data?.map((item: any, index: number) => {
        const Component: any = filtersMap[item.component] || EmptyFilter
        const isDefaultOpen =
          item.component === 'text-with-link' ||
          item.component === 'autocomplete'

        const isAgeAggregate = item?.name === 'Възраст'
        const monthRanges =
          isAgeAggregate &&
          item?.items
            ?.filter((el: any) =>
              getTranslatableField(el?.data?.meta?.valueLabel)
                ?.trim()
                ?.endsWith('м.')
            )
            ?.sort(customSort)
        const yearRanges =
          isAgeAggregate &&
          item?.items
            ?.filter((el: any) =>
              getTranslatableField(el?.data?.meta?.valueLabel)
                ?.trim()
                ?.endsWith('г.')
            )
            ?.sort(customSort)

        const ageItems = isAgeAggregate && [...monthRanges, ...yearRanges]

        const filter = !isAgeAggregate
          ? item
          : {
              ...item,
              items: ageItems,
            }

        return filter.items?.length ? (
          <FilterWrapper
            key={'FiltersWrapper__' + index}
            isDefaultOpened={isDefaultOpen}
            filterName={filter.name}
            filter={filter}
          >
            <Component data={filter} />
          </FilterWrapper>
        ) : null
      })}
    </>
  )
})
